import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { setCheckoutError, setCountryCode, setPostalCode } from 'features/billing/checkout_info_slice'
import { setError } from 'features/billing/create_subscription_slice'
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'
import { trackEvent } from 'hooks/analytics_events/useTrack'
import { uuidSelector } from 'selectors/current_user'

export const createCardToken = createAsyncThunk(
  'createCardToken',
  async ({ stripe, elements }, { rejectWithValue, dispatch, getState }) => {
    const result = await stripe.createToken(elements.getElement('card'))
    if (!result.token) {
      return rejectWithValue(result.error.message)
    }

    const state = getState()
    const userUuid = uuidSelector(state)
    const countryCode = result.token?.card?.country
    const postalCode = result.token?.card?.address_zip

    if (countryCode === 'US' && !postalCode) {
      dispatch(setError(HtmlParser(I18n.t('publisher.billing.checkout.order.steps.payment_method.require_us_zip_code'))))
      dispatch(setCheckoutError({
        type: 'payment_method',
        message: HtmlParser(I18n.t('publisher.billing.checkout.order.steps.payment_method.require_us_zip_code'))
      }))

      return rejectWithValue(I18n.t('publisher.billing.checkout.order.steps.payment_method.require_us_zip_code'))
    }

    // Using trackEvent instead of useTrack hook because this is a Redux thunk
    trackEvent({
      name: TRACKING_EVENT_NAMES.PAYMENT_METHOD_DETECTED,
      dependencies: { user_uuid: userUuid },
      properties: {
        payment_method: 'credit_card',
        billing_country_captured: countryCode,
        location: 'new_customer_checkout_flow'
      }
    })

    dispatch(setCountryCode(countryCode))

    if (postalCode) {
      dispatch(setPostalCode(postalCode))
    }

    return result.token
  }
)
